import React, { Component, PropTypes } from 'react';
import { RaisedButton, TextField, Paper } from 'material-ui';
import { Validation, fieldValidatorCore } from 'react-validation-framework';
import validator from 'validator';
import { css } from 'aphrodite';
import { Link, Redirect } from 'react-router-dom';
import { getValueFromChangeEvent, changeCallbackCaller } from '../../utils';
import styles from './auth-style';

export default class Signup extends Component {
  static propTypes = {
    authError: PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
    }),
    auth: PropTypes.shape({
      uid: PropTypes.string,
    }),
    firebase: PropTypes.objectOf(PropTypes.func).isRequired,
  }

  static defaultProps = {
    auth: null,
    authError: null,
  }

  state = {
    email: '',
    password: '',
    password2: '',
  }

  componentWillMount() {
    fieldValidatorCore.addSupport('TextField', getValueFromChangeEvent, changeCallbackCaller, 'errorText');
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSignup = () => {
    if (!this.isValid()) return false;
    const { firebase: { createUser } } = this.props;
    const { email, password } = this.state;
    return createUser({ email, password }, { email });
  }

  handleKeyDown = e => e.key === 'Enter' && this.handleSignup();

  isValid = () => fieldValidatorCore.checkGroup('signup').isValid;

  render() {
    const { authError, auth } = this.props;
    const { email, password, password2 } = this.state;

    if (auth) return <Redirect to={{ pathname: '/' }} />;

    return (
      <div className={css(styles.page)}>
        {authError &&
          <span className={css(styles.authError)}>
            {authError.message}
          </span>
        }
        <Paper className={css(styles.paper)}>
          <h1 className={css(styles.header)}>Create Account</h1>

          <Validation
            group="signup"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Email is required',
            }, {
              validator: val => validator.isEmail(val),
              errorMessage: 'Email must be valid',
            }]}
          >
            <TextField
              fullWidth
              required
              floatingLabelText="Email"
              name="email"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={css(styles.textField)}
              type="email"
              value={email}
            />
          </Validation>

          <Validation
            group="signup"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Password is required',
            }]}
          >
            <TextField
              fullWidth
              required
              floatingLabelText="Password"
              name="password"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={css(styles.textField)}
              type="password"
              value={password}
            />
          </Validation>

          <Validation
            group="signup"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Re-enter your password',
            }, {
              validator: val => validator.equals(val, password),
              errorMessage: 'Passwords must match',
            }]}
          >
            <TextField
              fullWidth
              required
              floatingLabelText="Re-enter Password"
              name="password2"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={css(styles.textField)}
              type="password"
              value={password2}
            />
          </Validation>

          <RaisedButton
            fullWidth
            label="Create New Account"
            className={css(styles.btn)}
            onClick={this.handleSignup}
          />

        </Paper>
        <Link to="/login" className={css([styles.link, styles.create])}>Back to Login</Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/signup.js